<template>
  <b-container
    fluid
    style="height: calc(100vh - 75px); overflow-y: auto; background-color: #ffffff;"
  >
  <b-overlay :show="isLoading" rounded="sm">
        <div>
        <b-row v-if="this.showDashboardIntro == 1">
          <b-col
            cols="8"
            offset="2"
          >
            <div class="align-middle my-5">
              <h3>{{$t("policies.privacyTitle")}}</h3>
              <div style="height:calc(100vh - 375px);overflow:auto;">
                <p v-html="sanitizeHtml($t('policies.privacyDescription'))"></p>
              </div>

              <b-form-checkbox
                class="text-center my-3"
                v-model="userConsent"
              >{{$t("questionnaires.consent")}}</b-form-checkbox>
              <b-button
                variant="outline-success"
                :disabled="!userConsent"
                class="mr-2"
                @click="onClickProceed()"
              >{{$t("questionnaires.proceed")}}</b-button>
            </div>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col cols="12">
            <b-breadcrumb
              v-if="$store.state.showSidebar && userType != 3"
              style="background-color:#f8f9fa"
              :items="itemsBreadcrumb"
            ></b-breadcrumb>
            <div>
              <NewDashboardTheme />
            </div>
          </b-col>
        </b-row>
      </div>
  </b-overlay>
  </b-container>
</template>

<script>
import { HTTP } from "../../utils/HTTP";
import { sanitizeHtml } from "@/utils/sanitizeHtml";
import NewDashboardTheme from "./employeeDashboard/newDashboardTheme.vue";
export default {
  name: "EmployeeDashboard",
  components: {
    NewDashboardTheme
  },

  data () {
    return {
      userType: null,
      userConsent: 0,
      showDashboardIntro: 1,
      isLoading: false,
      itemsBreadcrumb: [
        {
          text: "Dashboard",
          href: "#",
        },
      ],
    };
  },
  mounted () {
    this.userType = localStorage.getItem( "userType" );
    this.showDashboardIntro = localStorage.getItem( "showDashboardIntro" );
  },
  methods: {
    sanitizeHtml,
    onClickProceed () {
      localStorage.setItem( "showDashboardIntro", 0);
      this.showDashboardIntro = 0;
      this.updateEmployeeMetaData();
    },
    updateEmployeeMetaData () {
      this.isLoading = true;
      let userId = localStorage.getItem( "userId" );
      let employeeId = localStorage.getItem( "employeeId" );
      let token = "Bearer " + localStorage.getItem( "accessToken" );
        try {
          let response = HTTP(
            "get",
            "api/v1/employees/update/dashboard/intro/" +
              employeeId
          );
          try {
            if (response && response.data) {
            }
            this.isLoading = false;
          } catch (err) {
            this.isLoading = false;
            return [err];
          }
        } catch ( error ) {
          return [error];
        }
    },
  }
};
</script>

<style scoped>
@import "../../assets/styles/theme1/tabs.css";
@import "../../assets/styles/theme1/timeline.css";
/* @import "../../assets/styles/theme1/card.css"; */
@import "../../assets/styles/theme1/badge.css";
</style>

<style>
.table-hover tbody tr:hover td {
  background-color: rgb(255, 251, 242) !important;
}
</style>
